<template>
  <v-badge
    :value="count > 0"
    :dark="dark"
    :color="color"
    :offset-x="dot ? 10 : 16"
    :offset-y="dot ? 12 : 14"
    :dot="dot"
    :content="count"
    class="notification-icon-badge"
  >
    <BTooltipButton
      :loading="loading"
      :tooltip="tooltip"
      :class-button="classButton"
      depressed
      bottom
      v-on="$listeners"
    >
      <template #button-inner>
        <span class="notification-icon" v-html="icon" />
      </template>
    </BTooltipButton>
  </v-badge>
</template>

<script>
import variables from '@/assets/scss/exports.scss'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


const DOT_MAX_COUNT = 99

export default {
  name: 'NotificationsButton',
  components: {
    BTooltipButton,
  },
  props: {
    loading: Boolean,
    dark: Boolean,
    tooltip: String,
    classButton: [String, Object],
    count: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    color: variables['webflow-color-blue'],
    icon: null,
  }),
  computed: {
    dot() {
      return this.count > DOT_MAX_COUNT
    },
  },
  async created() {
    this.icon = (await import(
      '!raw-loader!@/../public/images/i-notification.svg'
    )).default
  },
}
</script>

<style lang="scss">
.notification-icon,
.notification-icon svg {
  height: 1rem;
}
</style>
